import { useStateParams } from '../../../../hooks/use-state-params';

export function useQueryInputParams() {
  return useStateParams<string | undefined>(undefined, 'query', query => query, query => query ?? undefined);
} 